import { render } from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=template&id=3522aad0&scoped=true"
import script from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditorCreateDialog.vue?vue&type=style&index=0&id=3522aad0&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3522aad0"]])

export default __exports__